import React from 'react';

import { useIntl } from 'react-intl';

import { IBaseProps } from '@rbi-ctg/frontend';
import Currency from 'components/currency';
import { usePaymentContext } from 'state/payment';
import { IPaymentMethod } from 'state/payment/types';

import { EndsInWrapper, GiftCardText, PrepaidBalance, PrepaidMethodType } from './styled';

interface IPrepaidMethodBalance extends IBaseProps {
  method: IPaymentMethod;
}

const PrepaidMethodBalance = ({ method }: IPrepaidMethodBalance) => {
  const { formatMessage } = useIntl();
  const { getBalanceFromPaymentMethods } = usePaymentContext();
  const prepaidCardNumber = method.prepaid?.cardNumber;
  const prepaidCardAlias = prepaidCardNumber?.slice(-4);
  return (
    <PrepaidMethodType>
      <GiftCardText>{formatMessage({ id: 'timsGiftCard' })}</GiftCardText>
      {prepaidCardAlias && (
        <>
          <EndsInWrapper>{formatMessage({ id: 'endsIn' })}</EndsInWrapper>
          <div data-testId="prepaid-card-alias">{prepaidCardAlias}</div>
        </>
      )}
      <span>-</span>
      <PrepaidBalance>
        <Currency amount={getBalanceFromPaymentMethods(method)} />
      </PrepaidBalance>
    </PrepaidMethodType>
  );
};

export default PrepaidMethodBalance;
